var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicePending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "invoice-pending-white-18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ledger-Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Invoices_Account-Number-Text-Tooltip",
    transform: "translate(-870.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(729.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invoice-pending-white-18dp",
    transform: "translate(141.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75,9 C10.68,9 9,10.68 9,12.75 C9,14.82 10.68,16.5 12.75,16.5 C14.82,16.5 16.5,14.82 16.5,12.75 C16.5,10.68 14.82,9 12.75,9 Z M13.9875,14.5125 L12.375,12.9 L12.375,10.5 L13.125,10.5 L13.125,12.5925 L14.5125,13.98 L13.9875,14.5125 Z M13.5,2.25 L4.5,2.25 C3.675,2.25 3,2.925 3,3.75 L3,15 C3,15.825 3.675,16.5 4.5,16.5 L9.0825,16.5 C8.64,16.0725 8.28,15.5625 8.0175,15 L4,15 L4,3.96508889 L14,3.96508889 L14,8.01 C14.5325,8.085 14.535,7.7925 15,8.01 L15,3.75 C15,2.925 14.325,2.25 13.5,2.25 Z M5,6 L13,6 L13,7 L5,7 L5,6 Z M5,9 L9,9 L9,10 L5,10 L5,9 Z M5,12 L8,12 L8,13 L5,13 L5,12 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePending);
export default __webpack_public_path__ + "static/media/invoice-pending.2966b6944e13c59c08a174b8e5a2e6db.svg";
export { ForwardRef as ReactComponent };